'use-client';

import * as React from 'react';
import style from './DesignedColumn.scss';
import Column from '../../Column';

const DesignedColumnSkin: React.ForwardRefRenderFunction<any, any> = (
  props,
  ref,
) => {
  const fillLayers = {
    ...(props.fillLayers || {}),
    extraClass: style.columnStyle,
  };

  return <Column {...props} fillLayers={fillLayers} ref={ref} />;
};

export default React.forwardRef(DesignedColumnSkin);
